export const PAGINATION_KIND_ONE_QUESTION_BY_PAGE = 'ONE_QUESTION_BY_PAGE'
export const PAGINATION_KIND_GROUP_QUESTIONS_BY_PAGE = 'GROUP_QUESTIONS_BY_PAGE'

export const PAGINATION_KINDS = [
  PAGINATION_KIND_ONE_QUESTION_BY_PAGE,
  PAGINATION_KIND_GROUP_QUESTIONS_BY_PAGE
]

export const QUESTION_KIND_FREE_TEXT = 'FREE_TEXT'
export const QUESTION_KIND_MULTIPLE_CHOICE = 'MULTIPLE_CHOICE'
export const QUESTION_KIND_RATINGS = 'RATINGS'

export const QUESTION_KINDS = [
  QUESTION_KIND_FREE_TEXT,
  QUESTION_KIND_MULTIPLE_CHOICE,
  QUESTION_KIND_RATINGS
]

export const STYLE_STANDARD = 'STANDARD'
export const STYLE_RECTANGLE_CHOICES = 'RECTANGLE_CHOICES'
export const STYLE_TEXT_AND_OR_IMAGE = 'TEXT_AND_OR_IMAGE'
export const STYLE_TEXT_AND_OR_BIG_IMAGE = 'TEXT_AND_OR_BIG_IMAGE'

export const STYLES = [
  STYLE_STANDARD,
  STYLE_RECTANGLE_CHOICES,
  STYLE_TEXT_AND_OR_IMAGE,
  STYLE_TEXT_AND_OR_BIG_IMAGE
]
